import {
  Badge,
  Box,
  Button,
  ComboBox,
  ComboboxAction,
  ComboBoxContent,
  ComboBoxInput,
  ComboBoxItem,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  Text
} from "@prismicio/editor-ui"
import { useState } from "react"

import { useEditorConfig } from "../../../EditorConfig"
import { MediaLibraryAssetCount } from "./MediaLibraryAssetCount"
import { useMediaLibrary } from "./MediaLibraryContext"

// TODO: remove mock tags in PBD-1382 https://linear.app/prismic/issue/PBD-1382/filter-media-search-with-tags
const tags = Array(20)
  .fill(0)
  .map((_, i) => ({ value: String(i) }))

export function MediaLibraryToolbar() {
  const { media, mediaTotal, setTagManagerOpen } = useMediaLibrary()
  const config = useEditorConfig()

  const [value, setValue] = useState("")
  const [open, setOpen] = useState(false)

  const mediaLibraryTagsEnabled =
    config.mediaLibrary && config.mediaLibraryTagsEnabled

  function onOpenChange(newOpen: boolean) {
    setOpen(newOpen)
  }

  function onItemSelected() {
    setOpen(false)
  }

  function onManageTags() {
    setOpen(false)
    setTagManagerOpen(open)
  }

  return (
    <Box alignItems="center" gap={16}>
      {media.length !== 0 && <MediaLibraryAssetCount count={mediaTotal} />}

      {mediaLibraryTagsEnabled && (
        <Box gap={8} alignItems="center">
          <Text>Filter:</Text>

          <DropdownMenu open={open} onOpenChange={onOpenChange}>
            <DropdownMenuTrigger>
              <Button
                startIcon="label"
                endIcon="arrowDropDown"
                size="small"
                color="grey"
              >
                Tags
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
              minWidth={256}
              align="start"
              border={false}
              childrenFocusScope
            >
              <ComboBox variant="attached">
                <ComboBoxInput
                  value={value}
                  onValueChange={setValue}
                  placeholder="Search for a tag"
                  // The combobox requires the input to be focused in order for
                  // it to be keyboard navigateable.
                  // setting autofocus means on open of the dropdown menu, we immediately
                  // focus into the combobox so that users can keyboard navigate
                  // eslint-disable-next-line jsx-a11y/no-autofocus
                  autoFocus
                />
                <ComboBoxContent>
                  {tags.map((tag) => (
                    <ComboBoxItem key={tag.value} onSelect={onItemSelected}>
                      <Badge
                        title={tag.value}
                        color="purple"
                        sx={{ marginBlock: 4, marginLeft: 8 }}
                        size="medium"
                      />
                    </ComboBoxItem>
                  ))}
                </ComboBoxContent>
                <ComboboxAction>
                  <Button
                    invisible
                    startIcon="edit"
                    textWeight="normal"
                    color="dark"
                    onClick={onManageTags}
                  >
                    Manage tags
                  </Button>
                </ComboboxAction>
              </ComboBox>
            </DropdownMenuContent>
          </DropdownMenu>
        </Box>
      )}
    </Box>
  )
}
